import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
export type UseFieldIdReturn = {
  fieldId: string;
  labelId: string;
};
export default function useFieldId(fieldName, id) {
  const $ = _c(4);
  const uid = useId();
  let t0;
  if ($[0] !== fieldName || $[1] !== id || $[2] !== uid) {
    t0 = id ? {
      fieldId: id,
      labelId: `label-${id}`
    } : {
      fieldId: `field-${fieldName}-${uid}`,
      labelId: `label-${fieldName}-${uid}`
    };
    $[0] = fieldName;
    $[1] = id;
    $[2] = uid;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}